// src/components/cart/CartIcon.js
import React from 'react';
import styled from 'styled-components';
import { useCart } from '../../hooks/useCart';
import { ShoppingCart } from 'lucide-react'; 

const CartIconWrapper = styled.div`
  position: relative;
  cursor: pointer;
`;



const CartCount = styled.span`
  position: absolute;
  top: -8px;
  right: -8px;
  background-color: #28a745;
  color: white;
  border-radius: 50%;
  padding: 2px 6px;
  font-size: 12px;
`;

const CartIcon = ({ onClick }) => {
  const { cartCount } = useCart();

  return (
    <CartIconWrapper onClick={onClick}>
        <ShoppingCart size={28} />
      {cartCount > 0 && <CartCount>{cartCount}</CartCount>}
    </CartIconWrapper>
  );
};

export default CartIcon;